var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8073 12.0317V1.15747C11.8073 0.850489 11.6589 0.556082 11.3948 0.339015C11.1307 0.121947 10.7726 0 10.3991 0C10.0256 0 9.66742 0.121947 9.40333 0.339015C9.13923 0.556082 8.99087 0.850489 8.99087 1.15747V14.8425C8.99087 15.9546 10.7056 16.415 11.5174 15.5437L15.589 12.1972C15.8525 11.98 16.0003 11.6857 16 11.3791C15.9997 11.0724 15.8514 10.7783 15.5875 10.5614C15.3237 10.3446 14.9659 10.2227 14.5928 10.2224C14.2197 10.2222 13.8617 10.3437 13.5975 10.5603L11.8073 12.0317ZM7.00921 14.8425V1.15747C7.00921 0.0454688 5.29452 -0.415 4.48264 0.456281L0.410999 3.80284C0.147547 4.02002 -0.000272755 4.31426 3.77837e-07 4.62095C0.000273511 4.92763 0.148617 5.22169 0.412456 5.43855C0.676294 5.65541 1.03406 5.77734 1.40718 5.77757C1.78031 5.77779 2.13829 5.65629 2.40251 5.43975L4.19271 3.96831V14.8425C4.19271 15.1495 4.34107 15.4439 4.60516 15.661C4.86925 15.8781 5.22744 16 5.60092 16C5.9744 16 6.33258 15.8781 6.59667 15.661C6.86077 15.4439 7.00913 15.1495 7.00913 14.8425H7.00921Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowSwap);
export default __webpack_public_path__ + "static/media/yellowSwap.af6798547fc4eac56ea807cda17d1fe7.svg";
export { ForwardRef as ReactComponent };